import React from "react";
import { Check, MessageCircle } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { dateTime } from "@/lib/format";

/** The four order milestones, each togglable with an optional WhatsApp nudge. */
export const ProjectMilestones = ({ milestones, names, clientPhone, busy, onToggle, onWhatsapp }) => {
  const { t } = useI18n();

  return (
    <section className="border border-[#2A2A2A] bg-[#0F0F0F] p-6 lg:p-8" data-testid="milestones-panel">
      <p className="eyebrow mb-6">{t("order_status")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {names.map((m) => {
          const done = !!milestones?.[m];
          return (
            <div key={m} className={`border p-4 ${done ? "border-[#D4AF37] bg-[#D4AF37]/10" : "border-[#2A2A2A]"}`}>
              <button data-testid={`milestone-${m}`} onClick={() => onToggle(m)} disabled={busy}
                className="text-left w-full min-h-[44px] py-1">
                <span className={`flex items-center gap-2 text-[11px] tracking-[0.16em] uppercase ${done ? "text-[#D4AF37]" : "text-[#A8A8A8]"}`}>
                  {done && <Check size={13} />} {t(`milestone_${m}`)}
                </span>
                <span className="mt-2 block font-mono-accent text-[10px] text-[#707070]">
                  {done ? dateTime(milestones[m]) : "—"}
                </span>
              </button>
              {done && clientPhone && (
                <button data-testid={`whatsapp-milestone-${m}`} onClick={() => onWhatsapp("milestone", m)}
                  className="mt-3 inline-flex items-center gap-1.5 min-h-[44px] text-[9px] tracking-[0.16em] uppercase text-[#D4AF37] hover:underline">
                  <MessageCircle size={11} /> {t("whatsapp")}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
